var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kf-contain"},[_c('iframe',{staticClass:"iframe-box",attrs:{"src":_vm.url,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }